import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Scheduler, Button, ContextMenu } from "devextreme-react";
import moment from "moment";
import validaciones from "../../../../../helpers/validaciones";
import { openCloseModalEditarScheduler, openCloseModalEliminarAppointment, doGetAppointments, addEmptyAppointments } from "./actions";

class FeriadosScheduler extends React.Component {
  constructor(props) {
    super(props);

    this.cellClick = null;
    this.state = {
      firstLoad: true,
      currentView: "6 meses",
    };

    props.dispatch(doGetAppointments());
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.listaAppointments === null
    ) {
      return false;
    }
    return true;
  }

  getNumberOfCupos = (startDate) => {
    let totalCupos = this.props.defaultTotalCupos;
    if (this.props.listaAppointments) {
      const cuposOnTime = this.props.listaAppointments.filter((i) => new Date(i.startDate).getTime() === new Date(startDate).getTime());
      totalCupos -= cuposOnTime.length;
    }
    return totalCupos;
  }

  resetClick = () => {
    this.cellClick = null;
  }

  handleAdd = (e) => {
    e.cancel = true;
    if (this.cellClick) {
      const isSameDate = validaciones.isSameDay(new Date(e.cellData.startDate), new Date(this.cellClick));
      if (isSameDate) {
        this.props.dispatch(openCloseModalEditarScheduler(true, {
          id: this.props.listaAppointments.length,
          ...e.cellData,
        }, false));
        this.cellClick = null;
      } else {
        this.cellClick = e.cellData.startDate;
      }
    } else {
      setTimeout(this.resetClick, 200);
      this.cellClick = e.cellData.startDate;
    }
  }

  handleEditar = (data) => {
    this.props.dispatch(openCloseModalEditarScheduler(true, data, true));
  }

  handleDobleClickToEdit = (e) => {
    e.cancel = true;
  }

  handleEliminar = (data) => {
    this.props.dispatch(openCloseModalEliminarAppointment(true, data));
  }


  handleContentReady = () => {
    if (this.state.firstLoad) {
      setTimeout(() => {
        const ele = document.getElementsByClassName("dx-scheduler-date-table-current-date");
        if (ele.length) {
          ele[0].scrollIntoView({ block: "center", inline: "center" });
        }
      }, 200);
      this.setState({ firstLoad: false });
    } else {
      setTimeout(() => {
        const ele = document.getElementsByClassName("dx-scheduler-date-table-cell dx-state-focused");
        if (ele.length) {
          ele[0].scrollIntoView({ block: "center", inline: "center" });
        }
      }, 200);
    }
  }
  renderAppointmentItem = (data, index, element) => {
    let item;
    switch (this.state.currentView) {
      case "6 meses": {
        item = (
          <div className="scheduler-tooltip">
            <span className="name">
              {data.repeatOnOff && <div className="material-icons">repeat</div>}
              {data.text}
            </span>
            <span className="centros">{(data.centers && data.centers.length) || "0"} centros</span>
            <span className="horario">
              {`${moment(data.startDate).format("HH:mm")} - ${moment(data.endDate).format("HH:mm")}`}
            </span>
          </div>
        );
        break;
      }
      case "Dia": {
        item = (
          <div className={`scheduler-boxes ${data.text ? "full" : "empty"}`} ></div>
        );
        break;
      }
      default:
        item = <div>{data.text}</div>;
        break;
    }
    ReactDOM.render(item, element);
  }
  renderTooltipBody = (data, element) => {
    ReactDOM.render(
      <div className="scheduler-tooltip">
        <h3 className="date">
          {validaciones.capitalizeFirstLetter(moment(data.startDate).format("dddd DD [de] MMMM"))}
        </h3>
        <span className="name">{data.text}</span>
        <span className="centros">{data.centers.length || "0"} centros</span>
        <span className="horario">
          {`${moment(data.startDate).format("HH:mm")} - ${moment(data.endDate).format("HH:mm")}`}
        </span>

        <div className="button-row">
          <div>
            <Button
              className="delete-button-outline"
              text="Eliminar"
              onClick={() => this.handleEliminar(data)}
            />
          </div>
          <div>
            <Button text="Editar" type="success" onClick={() => this.handleEditar(data)} />
          </div>
        </div>
      </div>
      , element
    );
  }


  renderContextMenu = ({ component, cellData, cellElement }) => {
    ReactDOM.render(
      <React.Fragment>
        <div className="cupos-scheduler">
            <div>{moment(cellData.startDate).format("DD")}</div>
        </div>
      <ContextMenu
        width={200}
        target={".scheduler-wrapper"}
        dataSource={[
          {
            text: "Agregar periodo",
            onClick: () => {
              this.props.dispatch(openCloseModalEditarScheduler(true, {
                startDate: cellData.startDate,
                endDate: cellData.endDate,
                id: this.props.listaAppointments.length,
              }, false));
            },
          },
        ]}
      />
      </React.Fragment>
      , cellElement
    );
  }

  renderCellTemplace = (data, index, element) => {
    let template;
    switch (this.state.currentView) {
      case "Dia": {
        template = (
          <div className="cupos-scheduler">
            <div className="total-cupos">{this.getNumberOfCupos(data.startDate)}</div>
          </div>
        );
        break;
      }
      default: {
        template = (
          <div>{data.text || ""}</div>
        );
        break;
      }
    }
    ReactDOM.render(template, element);
  }

  render() {
    let source = this.props.listaAppointments;
    if (this.state.currentView === "Dia") {
      source = addEmptyAppointments(this.props.listaAppointments, this.props.defaultTotalCupos);
    }
    return (
      <div className="scheduler-wrapper" style={{ marginBottom: 100 }}>
        <Scheduler
          dataSource={source}
          className="scheduler-year"
          defaultCurrentView={this.state.currentView}
          defaultCurrentDate={new Date()}
          startDayHour={9}
          endDayHour={20}
          cellDuration={30}
          views={[
            {
              name: "6 meses",
              type: "month",
              intervalCount: 6,
              maxAppointmentsPerCell: 1,
              firstDayOfWeek: 0,
            },
          ]}
          resources={[
            {
              allowMultiple: false,
              fieldExpr: "isDate",
              dataSource: [{ id: 1 }, { id: 2, color: "#e18e92" }],
            },
          ]}
          onContentReady={this.handleContentReady}
          appointmentTooltipTemplate={this.renderTooltipBody}
          appointmentTemplate={this.renderAppointmentItem}
          onCellContextMenu={this.renderContextMenu}
          onCellClick={this.handleAdd}
          onOptionChanged={(e) => {
            if (e.name === "currentView") {
              this.setState({ currentView: e.value });
            }
          }}
          onAppointmentDeleting={(e) => this.handleEliminar(e.appointmentData)}
          onAppointmentDblClick={this.handleDobleClickToEdit}

          dataCellTemplate={this.renderCellTemplace}
          onAppointmentClick={(e) => {
            if (e.appointmentElement.className.indexOf("dx-item dx-list-item") !== -1) {
              e.cancel = true;
              this.handleEditar(e.appointmentData);
            }
          }}

        >

        </Scheduler>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  listaAppointments: state.mantenedorFeriados.listaAppointments,
  defaultTotalCupos: state.mantenedorFeriados.defaultTotalCupos,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FeriadosScheduler);
